// extracted by mini-css-extract-plugin
module.exports = {"fadeInDuration":"600ms","root":"VideoPlayer-module--root--9rwhE","open":"VideoPlayer-module--open--3ZzAJ","close":"VideoPlayer-module--close--3Ilov"};